export default function CTA() {
  return (
    <section id="apply" className="relative overflow-hidden py-20 md:py-28">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20modern%20trade%20school%20workshop%20interior%20at%20dusk%2C%20workbenches%20with%20tools%20and%20cables%20laid%20out%2C%20warm%20amber%20accent%20lighting%20from%20above%2C%20industrial%20concrete%20walls%2C%20network%20racks%20visible%20in%20the%20background%2C%20subtle%20haze%2C%20dramatic%20mood%20lighting%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20texture%2C%20dark%20background%20with%20orange%20highlights&width=1920&height=1080&seq=techy-cta-bg-01&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/80 to-foreground-950/70"></div>

      <div className="relative w-full px-4 md:px-8">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/40 text-primary-300 text-xs font-mono uppercase tracking-[0.2em] mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            Ready when you are
          </div>
          <h2 className="text-background-50 font-heading font-bold text-4xl md:text-6xl leading-[1.05]">
            Pick up the phone. <br />
            <span className="text-primary-500">Pick up a new career.</span>
          </h2>
          <p className="mt-6 text-lg text-background-200 max-w-2xl leading-relaxed">
            Whether you're career-changing, fresh out of school, or leaving the service — we'll
            walk you through what's next in one honest phone call.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 sm:items-center">
            <a
              href="tel:8888663428"
              className="group inline-flex items-center justify-center sm:justify-start gap-4 px-5 sm:px-6 py-4 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 transition-colors cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-background-50/15 shrink-0">
                <i className="ri-phone-fill text-2xl"></i>
              </span>
              <span className="text-left min-w-0">
                <span className="block text-xs font-mono uppercase tracking-[0.2em] opacity-80">
                  Call admissions
                </span>
                <span className="block font-heading font-bold text-xl sm:text-2xl leading-none mt-1">
                  888-866-3428
                </span>
              </span>
            </a>
            <a
              href="#programs"
              className="inline-flex items-center gap-2 px-6 py-4 rounded-lg bg-background-50/10 hover:bg-background-50/20 border border-background-50/20 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer transition-colors backdrop-blur-sm"
            >
              Browse Programs
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-background-200">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-primary-400"></i> No prior experience required
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-primary-400"></i> Tools &amp; laptop included
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-primary-400"></i> Career placement support
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}